module.exports = __webpack_public_path__ + "static/media/laptop.4939e8a1.svg";